export default "__VITE_ASSET__DDO8dcuv__"